<template>
    <div>
        132
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>